<template>
  <v-autocomplete
    v-bind="$attrs"
    solo
    v-model="selected"
    :error-messages="error"
    clearable
    :items="provincesData"
    :label="label"
    :multiple="multiple"
    chips
    item-text="name"
    @input="onSelected"
    item-value="id"
    :counter="counter"
    :filter="customFilter"
    :class="inputCssClass"
  ></v-autocomplete>
</template>

<script>
import apiCtrl from '@/services/aru-services/aru-api.service.js';
export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    provinces: {
      type: Array,
    },
    value: {
      type: [Array, String, Number],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Provincias/Regiones',
    },
    inputCssClass: {
      type: [Object, String],
    },
    error: {
      type: String,
    },
    counter: {
      type: [Boolean, Number],
      default: false,
    },
  },
  data: () => ({
    provincesData: [],
    selected: [],
  }),
  mounted() {
    if (this.value) {
      this.selected = this.value;
    }
    if (this.provinces) {
      this.provincesData = this.provinces;
    } else {
      apiCtrl.get('/admin/aplifisa/fiscal-provinces').then(res => {
        this.provincesData = res.data.data;
      });
    }
  },
  methods: {
    onSelected() {
      this.$emit('input', this.selected);
    },
    customFilter(item, queryText) {
      const textOne = item
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      const searchText = queryText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

      return textOne.indexOf(searchText) > -1;
    },
  },
  computed: {
    //log() {
    //log = 'Computed';
    //console.log(log);
    //return log;
    //}
  },
  watch: {
    provinces: {
      handler: function(val, oldval) {
        this.provincesData = this.provinces;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
